import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import Icon from 'components/Icon'
import Button from 'components/UI/Button'

import './icon-button.pcss'

const IconButton = ({
    icon,
    iconColor,
    children,
    iconProps = {},
    flip,
    className,
    ...rest
}) => {
    return (
        <Button
            type="button"
            className={classNames('icon-button', className, {
                'icon-button--flip': flip,
            })}
            {...rest}
        >
            {icon && (
                <Icon
                    fa
                    name={icon}
                    color={iconColor || '#0088ee'}
                    {...iconProps}
                />
            )}
            {children && <span className="icon-button__content">{children}</span>}
        </Button>
    )
}

IconButton.propTypes = {
    icon: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.arrayOf(PropTypes.string)
    ]).isRequired,
    iconProps: PropTypes.shape(Icon.propTypes),
    iconColor: PropTypes.string,
    flip: PropTypes.bool,
    ...Button.propTypes,
}

export default IconButton
